import axios from 'axios'
import { API_BASE_URL } from '../../config/api'

export const createAPIClient = (baseURL = API_BASE_URL, withCredentials = true) => {
  return axios.create({
    baseURL,
    withCredentials
  })
}

export const friendsAPI = createAPIClient()